<template>
  <div class="slds-form-element">
    <input type="file" class="slds-file-selector__input slds-assistive-text" :accept="accept" :id="`file-upload-input-${uniqueId}`" @change="loadTextFromFile" :disabled="disabled" />
    <label class="slds-file-selector__body" :for="`file-upload-input-${uniqueId}`" id="file-selector-secondary-label">
      <span class="slds-file-selector__button slds-button slds-button_neutral">
        <svg class="slds-button__icon slds-button__icon_left" aria-hidden="true">
          <use xlink:href="../../assets/symbols.svg#upload"></use>
        </svg>
        <span v-if="label">{{label}}</span>
        <span v-else>{{$t('action.upload')}}</span>
      </span>
    </label>
  </div>
</template>
<script>
export default {
  props: {
    accept: String,
    disabled: Boolean,
    label: String
  },
  data () {
    return {
      uniqueId: parseInt(Math.random() * 1000),
      file: {}
    }
  },
  methods: {
    loadTextFromFile (event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = e => this.$emit('load', { content: e.target.result })
      reader.readAsText(file)
      event.target.value = '';
    }
  }
}
</script>
<style lang="scss" scoped>
  label {
    cursor: pointer;
  }
</style>
